import React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Tooltip,
  Chip,
  TablePagination
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';

const PostTable = ({ rows, onEditClick, onDeleteClick, onVisibilityChange, page, totalItems, onPageChange }) => {
  return (
    <TableContainer component={Paper} sx={{ width: '95%', margin: '20px auto', boxShadow: 'none', border: '1px solid #e0e0e0', borderRadius: '12px' }}>
      <Table>
        <TableHead sx={{ backgroundColor: '#f8f9fa' }}>
          <TableRow>
            <TableCell sx={{ fontWeight: 'bold', color: '#5F6A6A' }}>Titolo</TableCell>
            <TableCell sx={{ fontWeight: 'bold', color: '#5F6A6A' }}>Stato</TableCell>
            <TableCell sx={{ fontWeight: 'bold', color: '#5F6A6A' }}>Ultima Modifica</TableCell>
            <TableCell sx={{ fontWeight: 'bold', color: '#5F6A6A' }}>Creato il</TableCell>
            <TableCell sx={{ fontWeight: 'bold', color: '#5F6A6A', textAlign: 'center' }}>Azioni</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row) => (
            <TableRow key={row.id} hover>
              <TableCell sx={{minWidth: '150px'}}>{row.title}</TableCell>
              <TableCell>
                <Chip 
                  label={row.status === 'published' ? 'Pubblicato' : 'Bozza'} 
                  size="small"
                  sx={{ 
                    backgroundColor: row.status === 'published' ? '#e8f5e9' : '#fff3e0',
                    color: row.status === 'published' ? '#2e7d32' : '#ed6c02',
                    fontWeight: '500'
                  }}
                />
              </TableCell>
              <TableCell>{new Date(row.updated_at).toLocaleString('it-IT')}</TableCell>
              <TableCell>{new Date(row.created_at).toLocaleString('it-IT')}</TableCell>
              <TableCell sx={{ textAlign: 'center' }}>
                <Tooltip title="Modifica">
                  <IconButton onClick={() => onEditClick(row.id)} sx={{ color: '#5F6A6A' }}>
                    <EditIcon fontSize="small" />
                  </IconButton>
                </Tooltip>
                <Tooltip title={row.status === 'published' ? 'Sposta in Bozza' : 'Pubblica'}>
                  <IconButton onClick={() => onVisibilityChange(row.id, row.status)} sx={{ color: '#ff0f64' }}>
                    {row.status === 'published' ? <VisibilityOffIcon fontSize="small" /> : <VisibilityIcon fontSize="small" />}
                  </IconButton>
                </Tooltip>
                <Tooltip title="Elimina">
                  <IconButton onClick={() => onDeleteClick(row.id)} sx={{ color: '#d32f2f' }}>
                    <DeleteIcon fontSize="small" />
                  </IconButton>
                </Tooltip>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      <TablePagination
        component="div"
        count={totalItems}
        page={page}
        onPageChange={onPageChange}
        rowsPerPage={10}
        rowsPerPageOptions={[10]}
        labelRowsPerPage="Post per pagina:"
        labelDisplayedRows={({ from, to, count }) => `${from}-${to} di ${count}`}
      />
    </TableContainer>
  );
};

export default PostTable;
